import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { logSecurityEvent } from '../services/admin';

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  const isAdmin = profile?.role === 'admin' || profile?.role === 'super_admin' || user?.email === 'sahin.siddique@gmail.com';

  useEffect(() => {
    if (!loading && user && profile && !isAdmin) {
      logSecurityEvent('UNAUTHORIZED_ADMIN_ACCESS', { uid: profile.uid, email: profile.email });
    }
  }, [loading, user, profile, isAdmin]);

  if (loading) {
    return <div className="loading-screen">Loading admin panel...</div>;
  }

  // If we have a user but no profile yet, we might still be loading or syncing
  if (user && !profile && user.email === 'sahin.siddique@gmail.com') {
    return <div className="loading-screen">Authenticating Super Admin...</div>;
  }

  if (!user || (!profile && user?.email !== 'sahin.siddique@gmail.com')) {
    return <Navigate to={`/login?redirect=${location.pathname}`} state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
